import React from "react";
import { statusInfo } from "../../api/ideas";
import { ArrowRightIcon } from "./IdeasIcons";

/**
 * Вертикальный timeline истории статусов идеи.
 * Источник: idea.status_history (массив {from, to, changed_at, comment, changed_by})
 */
export default function IdeaStatusTimeline({ history }) {
  if (!history || history.length === 0) {
    return <div className="idz-hint">История пуста</div>;
  }
  return (
    <div className="idz-timeline">
      {history.map((h, i) => (
        <div
          key={i}
          className={
            "idz-tl-item" +
            (h.to === "done" ? " is-done" : "") +
            (h.to === "rejected" ? " is-rejected" : "")
          }
        >
          <div className="idz-tl-status">
            {h.from ? (
              <>
                {statusInfo(h.from).label} <ArrowRightIcon /> {statusInfo(h.to).label}
              </>
            ) : (
              `Создана: ${statusInfo(h.to).label}`
            )}
          </div>
          <div className="idz-tl-when">{formatDate(h.changed_at)}</div>
          {h.comment && <div className="idz-tl-cmt">«{h.comment}»</div>}
        </div>
      ))}
    </div>
  );
}

function formatDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleString("ru-RU", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
